// 20260409 - rlai - Customer Account ID field

class EnercareAccountField extends HTMLElement {
  constructor() {
    super();
    this.accountPrefix = '5000';
    this.suffixRegex = /^[0-9]{12}$/;
    this.suffixInput = this.querySelector('.enercare-account-field__suffix-input');
    this.input = this.querySelector('.enercare-account-field__input');
    this.error = this.querySelector('.enercare-account-field__error');
    this.checkoutButton = this._findCheckoutButton();
    this.debounceTimer = null;
    this.regex = new RegExp('^' + this.accountPrefix + '[0-9]{12}$');
  }

  connectedCallback() {
    if (!this.input) return;

    var saved = this.getAttribute('data-saved-value') || '';
    var normalized = this._normalizeSavedValue(saved);

    if (this.suffixInput) {
      this.suffixInput.value = normalized.slice(this.accountPrefix.length);
    } else {
      this.input.value = normalized;
    }

    this.input.addEventListener('input', this._onInput.bind(this));
    this.input.addEventListener('blur', this._onBlur.bind(this));
  }

  _normalizeSavedValue(value) {
    var digitsOnly = String(value || '').replace(/\D/g, '');

    if (this.regex.test(digitsOnly)) {
      return digitsOnly;
    }

    if (/^[0-9]{12}$/.test(digitsOnly)) {
      return this.accountPrefix + digitsOnly;
    }

    return this.accountPrefix;
  }

  _findCheckoutButton() {
    var parent = this.parentElement;
    while (parent) {
      var btn = parent.querySelector('button[name="checkout"]');
      if (btn) return btn;
      parent = parent.parentElement;
    }
    return document.querySelector('button[name="checkout"]');
  }

  _onInput(e) {
    var value = e.target.value.trim();
    if (value.length > 12) {
      value = value.slice(0, 12);
      e.target.value = value;
    }

    clearTimeout(this.debounceTimer);

    if (value === '') {
      this._hideError();
      this._enableCheckout();
      this._debouncedSave('');
      return;
    }

    if (/\D/.test(value)) {
      this._showError();
      this._disableCheckout();
      return;
    }

    if (value.length < 12) {
      this._hideError();
      this._enableCheckout();
      return;
    }

    this._validateAndSave(value);
  }

  _onBlur(e) {
    var value = e.target.value.trim();
    this._validateAndSave(value);
  }

  _validateAndSave(value) {
    if (value === '') {
      this._hideError();
      this._enableCheckout();
      this._debouncedSave('');
      return;
    }

    if (!this.suffixRegex.test(value)) {
      this._showError();
      this._disableCheckout();
      return;
    }

    var fullValue = this.accountPrefix + value;
    if (!this.regex.test(fullValue)) {
      this._showError();
      this._disableCheckout();
      return;
    }

    this._hideError();
    this._enableCheckout();
    this._debouncedSave(fullValue);
  }

  _debouncedSave(value) {
    var self = this;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(function () {
      self._saveToCart(value);
    }, 400);
  }

  _saveToCart(value) {
    var data = { attributes: { customer_account_id: value || '' } };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        console.log('✅ Account ID saved:', value || '(cleared)');
      })
      .catch(function (err) {
        console.error('❌ Failed to save account ID:', err);
      });
  }

  _showError() {
    if (this.error) {
      this.error.hidden = false;
    }
  }

  _hideError() {
    if (this.error) {
      this.error.hidden = true;
    }
  }

  _disableCheckout() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.setAttribute('aria-disabled', 'true');
    }
  }

  _enableCheckout() {
    if (this.checkoutButton) {
      this.checkoutButton.removeAttribute('aria-disabled');
      if (!this.checkoutButton.closest('[class*="is-empty"]')) {
        this.checkoutButton.disabled = false;
      }
    }
  }
}

if (!customElements.get('enercare-account-field')) {
  customElements.define('enercare-account-field', EnercareAccountField);
}
